export enum CallState {
  notInitiated = 'notInitiated',
  connecting = 'connecting',
  connected = 'connected',
  terminated = 'terminated',
  failed = 'failed',
}
